(function (global) {
  'use strict';

  var validationCache = {};

  function storageKey() {
    if (global.theme && theme.StoreLists && theme.StoreLists.lists && theme.StoreLists.lists.wishlist) {
      return theme.StoreLists.lists.wishlist.current_storage;
    }
    return 'wishlist-guest';
  }

  function parse(raw) {
    if (!raw) return null;
    try {
      var value = JSON.parse(raw);
      return Array.isArray(value) ? value : null;
    } catch (error) {
      return null;
    }
  }

  function read() {
    var key = storageKey();
    var canonical = parse(global.localStorage && localStorage.getItem(key));
    if (canonical) return { key: key, items: canonical };
    var fallbacks = ['wishlist-guest', 'shopify_wishlist_handles', 'shopify_wishlist'];
    for (var index = 0; index < fallbacks.length; index += 1) {
      var items = parse(global.localStorage && localStorage.getItem(fallbacks[index]));
      if (items && items.length) return { key: key, items: items };
    }
    return { key: key, items: [] };
  }

  function normalizeHandle(value) {
    if (typeof value !== 'string') return '';
    return value.trim().replace(/^\/?products\//, '').replace(/\?.*$/, '').replace(/\/$/, '');
  }

  function handles(items) {
    var result = [];
    var seen = {};
    (items || []).forEach(function (entry) {
      if (typeof entry === 'string') {
        var direct = normalizeHandle(entry);
        if (direct && !seen[direct]) { seen[direct] = true; result.push(direct); }
        return;
      }
      if (!entry || typeof entry !== 'object') return;
      Object.keys(entry).forEach(function (id) {
        var handle = normalizeHandle(entry[id]);
        if (handle && !seen[handle]) { seen[handle] = true; result.push(handle); }
      });
    });
    return result;
  }

  function filterItems(items, invalidHandles) {
    var invalid = {};
    invalidHandles.forEach(function (handle) { invalid[handle] = true; });
    return (items || []).filter(function (entry) {
      if (typeof entry === 'string') return !invalid[normalizeHandle(entry)];
      if (!entry || typeof entry !== 'object') return false;
      return Object.keys(entry).some(function (id) { return !invalid[normalizeHandle(entry[id])]; });
    });
  }

  function productJsonUrl(handle) {
    var root = global.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return String(root).replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function write(data, invalidHandles) {
    var validItems = filterItems(data.items, invalidHandles);
    var validHandles = handles(validItems);
    localStorage.setItem(data.key, JSON.stringify(validItems));
    localStorage.setItem('shopify_wishlist_handles', JSON.stringify(validHandles));
    localStorage.setItem('shopify_wishlist', JSON.stringify(validHandles));
    if (data.key === 'wishlist-guest') localStorage.setItem('wishlist-guest', JSON.stringify(validItems));
    document.dispatchEvent(new CustomEvent('rw:wishlist-changed', {
      detail: { count: validHandles.length, handles: validHandles.slice(), removed: invalidHandles.slice() }
    }));
    return validHandles;
  }

  function validate() {
    var data = read();
    var currentHandles = handles(data.items);
    var signature = data.key + '|' + currentHandles.join('|');
    if (!currentHandles.length || validationCache[signature] === true) {
      return Promise.resolve({ changed: false, handles: currentHandles, removed: [] });
    }
    if (validationCache[signature]) return validationCache[signature];

    validationCache[signature] = Promise.all(currentHandles.map(function (handle) {
      return fetch(productJsonUrl(handle), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.status === 404 ? handle : ''; })
        .catch(function () { return ''; });
    })).then(function (results) {
      var invalid = results.filter(Boolean);
      validationCache[signature] = true;
      if (!invalid.length) return { changed: false, handles: currentHandles, removed: [] };
      var validHandles = write(data, invalid);
      return { changed: true, handles: validHandles, removed: invalid };
    }).catch(function () {
      validationCache[signature] = true;
      return { changed: false, handles: currentHandles, removed: [] };
    });
    return validationCache[signature];
  }

  global.RwadyWishlistStore = {
    read: read,
    handles: function () { return handles(read().items); },
    count: function () { return handles(read().items).length; },
    validate: validate
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeHandle: normalizeHandle, handles: handles, filterItems: filterItems };
  }
}(typeof window !== 'undefined' ? window : globalThis));
